module.exports = __webpack_public_path__ + "static/media/Fire_Panel.5aa8c003.png";